import { createSelector } from 'reselect';
import { getOrderProgress } from './getOrderProgress';
import { getApmCurrentOrderQuantity } from './getApmCurrentOrderQuantity';

/**
 * Good parts toward the order across every machine on the operation when the Dashboard sends them,
 * else this machine's order progress. Parts remaining and time estimates are worked out from it;
 * getOrderProgress stays this machine's own for the "Made" counts.
 */
export const getOperationOrderProgress = createSelector(
  [getOrderProgress, getApmCurrentOrderQuantity],
  (orderProgress, apmCurrentOrderQuantity) => {
    return apmCurrentOrderQuantity?.operationGoodQuantity ?? orderProgress;
  }
);
